import React from 'react'
import { type RunContextItemOf, type RunContextKind } from '../../../store/customWorkflow/customWorkflows'
import { AiAgentResultLink, CcqExecutionLink, ContactLink, ContextLabel, DocumentLink, InsightsScope, MeetingLink } from './renderers'

export interface ContextKindSpec<K extends RunContextKind> {
  keyOf: (item: RunContextItemOf<K>) => string | undefined
  Renderer: (props: { item: RunContextItemOf<K>; accountId: string }) => React.ReactElement | null
}

export const CONTEXT_KINDS: { [K in RunContextKind]: ContextKindSpec<K> } = {
  contact: { keyOf: (item) => item.contactId, Renderer: ContactLink },
  ccqExecution: { keyOf: (item) => item.executionId, Renderer: CcqExecutionLink },
  aiAgentResult: { keyOf: (item) => item.aiAgentResultKey, Renderer: AiAgentResultLink },
  event: { keyOf: (item) => item.eventType, Renderer: ContextLabel },
  meeting: { keyOf: (item) => `${item.roomId}:${item.sessionId}`, Renderer: MeetingLink },
  document: { keyOf: (item) => item.documentId, Renderer: DocumentLink },
  insights: { keyOf: (item) => `${item.fromDate ?? ''}:${item.toDate ?? ''}:${item.userIds.join(',')}`, Renderer: InsightsScope },
}

export const isKnownKind = (kind: string): kind is RunContextKind => Object.hasOwn(CONTEXT_KINDS, kind)

export const contextItemKey = <K extends RunContextKind>(item: RunContextItemOf<K>): string | undefined =>
  isKnownKind(item.kind) ? CONTEXT_KINDS[item.kind].keyOf(item) : undefined
